import React from 'react';
import { UserContext } from '../UserProvider';

export const DataContext = React.createContext();

const ENDPOINT = process.env.REACT_APP_API_URL;

function DataProvider({ children }) {
  const [apiWasRequested, setApiWasRequested] = React.useState(false);
  const [requestWasHandled, setRequestWasHandled] = React.useState(false);
  const [selectedCourse, setSelectedCourse] = React.useState(null);
  const [selectedCourseTitle, setSelectedCourseTitle] = React.useState(null);
  const [selectedVideoId, setSelectedVideoId] = React.useState('');
  const [selectedQuizId, setSelectedQuizId] = React.useState('');
  const [selectedEpisodeNumber, setSelectedEpisodeNumber] = React.useState('');
  const [videoUrl, setVideoUrl] = React.useState('');
  const [catalogWasRequested, setCatalogWasRequested] = React.useState(true);
  const [catalogWasFetched, setCatalogWasFetched] = React.useState(false);
  const [lessonsWereRequested, setLessonsWereRequested] = React.useState(false);
  const [lessonsWereFetched, setLessonsWereFetched] = React.useState(false);
  const [selectedExerciseIndex, setSelectedExerciseIndex] = React.useState(0);
  const [currPositionIndex, setCurrPositionIndex] = React.useState(0);

  const [exerciseWasRequested, setExerciseWasRequested] = React.useState(false);
  const [exerciseWasFetched, setExerciseWasFetched] = React.useState(false);
  const [exerciseData, setExerciseData] = React.useState([]);

  const [sections, setSections] = React.useState([]);
  const [courseProgress, setCourseProgress] = React.useState({});

  const [lessons, setLessons] = React.useState([]);
  const [catalog, setCatalog] = React.useState([]);
  // const [items, setItems] = React.useState({
  //   items: {},
  //   columns: {
  //     'column-1': {
  //       id: 'column-1',
  //       title: 'All',
  //       itemIds: [],
  //     },
  //   },
  //   columnOrder: ['column-1'],
  // });

  const { token } = React.useContext(UserContext);

  React.useEffect(() => {
    async function getLessons() {
      const URL = ENDPOINT + `lessons?key=${selectedCourse}`;
      const HEADERS = {
        'Content-Type': 'application/json',
        Authorization: token,
      };
      const request = new Request(URL, {
        method: 'GET',
        headers: HEADERS,
        timeout: 100000,
      });
      const response = await fetch(request);
      const json = await response.json();
      const jsonLessonsString = json.LESSONS;
      const jsonCourseProgressString = json.COURSE;
      const jsonLessons = JSON.parse(jsonLessonsString);
      const jsonCourseProgress = JSON.parse(jsonCourseProgressString);
      setLessons(jsonLessons);
      setCourseProgress(jsonCourseProgress);
      const sortedSections = Object.entries(jsonCourseProgress)
        .sort((a, b) => {
          const indexA = parseInt(a[0].split('#')[0], 10);
          const indexB = parseInt(b[0].split('#')[0], 10);
          return indexA - indexB;
        })
        .map(([key, value]) => ({ [key]: value }));
      let firstIncompleteLesson = null;

      for (let i = 0; i < sortedSections.length; i++) {
        const sectionLessons =
          sortedSections[i][Object.keys(sortedSections[i])[0]];
        for (let j = 0; j < sectionLessons.length; j++) {
          const lesson = sectionLessons[j];
          if (lesson.status == 'INCOMPLETE') {
            firstIncompleteLesson = lesson;
            break;
          }
        }
        if (firstIncompleteLesson) break;
      }

      if (firstIncompleteLesson) {
        const matchingLesson = jsonLessons.find(
          (lesson) =>
            lesson.episode_number === firstIncompleteLesson.episode_number
        );

        if (matchingLesson.episode_id) {
          setSelectedVideoId(matchingLesson.episode_id);
          setSelectedEpisodeNumber(matchingLesson.episode_number);
          setSelectedQuizId('');
          setApiWasRequested(true);
          setRequestWasHandled(false);
        } else {
          setSelectedQuizId(matchingLesson.episode_number);
          setSelectedVideoId('');
          setSelectedEpisodeNumber('');
          setExerciseWasRequested(true);
          setExerciseWasFetched(false);
        }
      }

      // WARNING: DO NOT DELETE!!!
      // const newTask = {
      //   id: taskUlid,
      //   content: task,
      //   project,
      //   status: 'INCOMPLETE',
      // };
      //   setItems((oldItems) => {
      //     const lessonItems = jsonLessons.reduce((acc, lesson, index) => {
      //       acc[lesson.episode_number] = {
      //         ...lesson,
      //         id: lesson.episode_number,
      //         content: lesson.title,
      //         status: 'INCOMPLETE',
      //         course: selectedCourse,
      //         section: 'NULL',
      //         globalIndex: index,
      //         type: 'LESSON',
      //       };
      //       return acc;
      //     }, {});

      //     const sectionItems = jsonSections.reduce((acc, section, index) => {
      //       acc[section] = {
      //         id: section,
      //         content: section,
      //         status: 'INCOMPLETE',
      //         course: selectedCourse,
      //         section: section,
      //         sectionIndex: index,
      //         type: 'SECTION',
      //       };
      //       return acc;
      //     }, {});
      //     const combinedItems = { ...sectionItems, ...lessonItems };
      //     // const allItems = sectionItems.concat(lessonItems);
      //     const sectionIds = Object.keys(sectionItems);
      //     const allIds = [
      //       ...Object.values(lessonItems)
      //         .sort((a, b) => a.globalIndex - b.globalIndex) // Sort lessons by globalIndex
      //         .map((lesson) => lesson.id), // Extract lesson IDs
      //       ...sectionIds,
      //     ];
      //     return {
      //       items: combinedItems,
      //       columns: {
      //         'column-1': {
      //           id: 'column-1',
      //           title: 'All',
      //           itemIds: allIds,
      //         },
      //       },
      //       columnOrder: ['column-1'],
      //     };
      //   });
      return json;
    }
    if (
      lessonsWereRequested &&
      !lessonsWereFetched &&
      selectedCourse !== '' &&
      token
    ) {
      getLessons();
      setLessonsWereRequested(false);
      setLessonsWereFetched(true);
    }
  }, [lessonsWereRequested, lessonsWereFetched, selectedCourse, token]);

  React.useEffect(() => {
    async function getCatalog() {
      const URL = ENDPOINT + `catalog`;
      const HEADERS = {
        'Content-Type': 'application/json',
        Authorization: token,
      };
      const request = new Request(URL, {
        method: 'GET',
        headers: HEADERS,
        timeout: 100000,
      });
      const response = await fetch(request);
      const json = await response.json();
      setCatalog(json);
      return json;
    }
    if (catalogWasRequested && !catalogWasFetched && token) {
      getCatalog();
      setCatalogWasRequested(false);
      setCatalogWasFetched(true);
    }
  }, [catalogWasRequested, catalogWasFetched, catalog, token]);

  React.useEffect(() => {
    async function fetchExercise() {
      const URL = ENDPOINT + `exercise?key=${selectedQuizId}`;

      const request = new Request(URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        timeout: 100000,
      });

      const response = await fetch(request);
      const json = await response.json();
      setExerciseData(json);
      return json;
    }
    if (exerciseWasRequested && !exerciseWasFetched) {
      fetchExercise();
      setExerciseWasRequested(false);
      setExerciseWasFetched(true);
    }
  }, [exerciseWasRequested, exerciseWasFetched]);

  React.useEffect(() => {
    async function fetchData() {
      const URL = ENDPOINT + `video?key=${selectedVideoId}`;

      const request = new Request(URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        timeout: 100000,
      });

      const response = await fetch(request);
      const json = await response.json();
      setVideoUrl(json.presigned_url);
      return json.presigned_url;
    }
    if (apiWasRequested && !requestWasHandled) {
      fetchData();
      setApiWasRequested(false);
      setRequestWasHandled(true);
    }
  }, [apiWasRequested, requestWasHandled]);

  return (
    <DataContext.Provider
      value={{
        // items,
        // setItems,
        setApiWasRequested,
        setRequestWasHandled,
        setSelectedVideoId,
        setSelectedQuizId,
        selectedCourse,
        setSelectedCourse,
        selectedVideoId,
        selectedQuizId,
        videoUrl,
        catalog,
        setCatalogWasRequested,
        setCatalogWasFetched,
        setLessonsWereRequested,
        setLessonsWereFetched,
        lessons,
        sections,
        setSections,
        courseProgress,
        setCourseProgress,
        setLessons,
        selectedCourseTitle,
        setSelectedCourseTitle,
        exerciseData,
        setExerciseData,
        setExerciseWasRequested,
        setExerciseWasFetched,
        exerciseWasFetched,
        selectedEpisodeNumber,
        setSelectedEpisodeNumber,
        selectedExerciseIndex,
        setSelectedExerciseIndex,
        currPositionIndex,
        setCurrPositionIndex,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export default DataProvider;
